var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExchage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wz9av5gaga",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.403922 0 0 0 0 0.156863 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#wz9av5gaga)",
    transform: "translate(-28.000000, -406.000000) translate(16.000000, 379.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#212529",
    fillRule: "nonzero",
    d: "M3.79 1.677c0-.146-.046-.263-.139-.351-.093-.088-.217-.132-.373-.132-.069 0-.133.01-.194.033-.061.022-.121.057-.18.106L.231 3.383c-.152.118-.228.272-.23.462-.003.19.074.347.23.469l2.673 2.058c.059.054.119.092.18.114.06.022.125.033.194.033.156 0 .28-.046.373-.136.093-.09.14-.209.14-.355V4.336H8.5c.742 0 1.377-.13 1.904-.392.528-.261.934-.635 1.22-1.12.285-.486.428-1.069.428-1.747V.579c0-.157-.057-.292-.172-.407C11.765.057 11.63 0 11.473 0c-.156 0-.29.057-.402.172-.113.115-.169.25-.169.407v.38c0 .704-.2 1.258-.6 1.663-.4.405-.945.608-1.634.608H3.79V1.677z",
    transform: "translate(18.538751, 30.331055) scale(-1, 1) translate(-18.538751, -30.331055) translate(12.512695, 27.071777)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExchage);
export default __webpack_public_path__ + "static/media/ic_exchage.8b6c2b651531a1a15b616d570d97b15e.svg";
export { ForwardRef as ReactComponent };